import { IShift } from 'models/Shift'
import { Action } from 'redux'
import { isType } from 'ts-action'
import {
  GetUpshifterMyShifts,
  UpshifterMyShiftsFetching,
  ClearUpshifterMyShiftsReducer,
  UpshifterMyShiftsSetHasMore,
  UpshifterMyShiftsFavoriteBusiness,
  UpshifterMyShiftsUnfavoriteBusiness,
  UpshifterMyShiftsUpdateShift,
  UpshifterMyShiftsRemoveShift,
} from './actions'
import { IBaseReducer } from 'models/BaseReducer'
import { updateArray, deleteFromArray } from 'helpers/helperFuncs'
import { IPagination } from 'models/Global'

interface IShiftsReducer extends IBaseReducer<IShift[]> {
  hasMore: boolean
}

const initialState: IShiftsReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
  hasMore: false,
}

export const upshifterMyShiftsReducer = (
  state = initialState,
  action: Action,
): IShiftsReducer => {
  if (isType(action, GetUpshifterMyShifts)) {
    const { data, meta } = action.payload
    const hasMore = meta.pagination
      ? meta.pagination.total_pages > meta.pagination.current_page
      : false
    return {
      ...state,
      meta: meta,
      data: [...state.data, ...data],
      hasMore,
      error: undefined,
    }
  }
  if (isType(action, UpshifterMyShiftsFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  if (isType(action, UpshifterMyShiftsSetHasMore)) {
    const { payload } = action
    return {
      ...state,
      hasMore: payload,
    }
  }
  if (isType(action, UpshifterMyShiftsUpdateShift)) {
    const { payload } = action
    const formattedArray = updateArray<IShift>(state.data, payload)
    return {
      ...state,
      data: formattedArray,
    }
  }
  if (isType(action, UpshifterMyShiftsRemoveShift)) {
    const { payload: id } = action
    const { meta } = state
    const formattedArray = deleteFromArray<IShift>(state.data, id)
    return {
      ...state,
      data: formattedArray,
      meta: {
        ...meta,
        pagination: {
          ...meta.pagination,
          total: meta.pagination ? meta.pagination.total - 1 : 0,
        } as IPagination,
      },
    }
  }
  if (isType(action, UpshifterMyShiftsFavoriteBusiness)) {
    const { payload } = action
    const modifiedShifts = state.data.map(shift => {
      if (shift.business_id === payload.model_favored.id) {
        const modifiedShift = shift
        modifiedShift.favored = true
        modifiedShift.favorite_id = payload.id
        return modifiedShift
      }
      return shift
    })
    return {
      ...state,
      data: modifiedShifts,
    }
  }
  if (isType(action, UpshifterMyShiftsUnfavoriteBusiness)) {
    const { payload } = action
    const unfavoritedShifts = state.data.map(shift => {
      if (shift.business_id === payload) {
        const unfavoritedShift = shift
        unfavoritedShift.favored = false
        unfavoritedShift.favorite_id = null
        return unfavoritedShift
      }
      return shift
    })
    return {
      ...state,
      data: unfavoritedShifts,
    }
  }
  if (isType(action, ClearUpshifterMyShiftsReducer)) {
    return initialState
  }
  return state
}
